export enum OCRFieldAction {
    APPROVE = 'Approve',
    REJECT = 'Reject',
    OVERRIDE = 'Override'
}

export const ocrFieldActionDisplay: Record<OCRFieldAction, string> = {
    [OCRFieldAction.APPROVE]: 'Approve',
    [OCRFieldAction.REJECT]: 'Reject',
    [OCRFieldAction.OVERRIDE]: 'Override'
};
